import React, {FC} from "react"

import Button, {IconTypes} from "@irati/ui/src/Button"
import {ButtonRouterLink} from "@irati/ui/src/Link"
import Icon from "@irati/ui/src/Icon"
import FormattedMessage from "@irati/utils/lang"

import {ORDER_MANAGEMENT} from "../../../routes/routeConfig"

interface Props {
  onClick?: () => void
}

const BackLink: FC<Props> = ({onClick}) => {
  if (onClick) {
    return (
      <Button tertiary onClick={onClick} marginTop={2} marginBottom={2}>
        <Icon icon={IconTypes.chevronLeft} marginRight />
        <FormattedMessage id="admin.components.orderManagement.backLink.btn" />
      </Button>
    )
  }
  return (
    <ButtonRouterLink tertiary to={ORDER_MANAGEMENT} marginTop={2} marginBottom={2}>
      <Icon icon={IconTypes.chevronLeft} marginRight />
      <FormattedMessage id="admin.components.orderManagement.backLink.btn" />
    </ButtonRouterLink>
  )
}

export default BackLink
